
          <div
            class="preview"
            [class.preview--launch-enabled]="launchToProductionEnabled"
            [class.preview--production]="launchToProductionEnabled && isLaunchedToProduction(portal)"
          >
            @if (launchToProductionEnabled) {
              <div class="launch-status-bar" [class.launch-status-bar--production]="isLaunchedToProduction(portal)">
                <div class="launch-status-bar__state">
                  @if (isLaunchedToProduction(portal)) {
                    <span class="launch-status-bar__badge launch-status-bar__badge--production">{{ 'myPortal.launch.productionBadge' | translate }}</span>
                    <span class="launch-status-bar__detail">
                      {{ 'myPortal.launch.productionDescription' | translate }}
                    </span>
                  } @else {
                    <span class="launch-status-bar__badge">{{ 'myPortal.launch.testingBadge' | translate }}</span>
                    <span class="launch-status-bar__detail">
                      {{ 'myPortal.launch.testingDescription' | translate }}
                    </span>
                  }
                </div>
                @if (canLaunchToProduction(portal)) {
                  <button type="button" class="launch-status-bar__action" (click)="openLaunchConfirmation(portal)">
                    {{ 'myPortal.launch.action' | translate }}
                  </button>
                }
              </div>
              @if (isLaunchedToProduction(portal)) {
                <div class="launch-production-info">
                  <div class="launch-production-info__left">
                    <span class="launch-production-info__icon">
                      <img src="/assets/icons/rocket.svg" alt="">
                    </span>
                    <span class="launch-production-info__text">
                      <span>{{ 'myPortal.launch.launchedInfo' | translate }}</span>
                      @if (getLaunchUserName(portal)) {
                        <strong>{{ 'myPortal.launch.byUser' | translate:{ user: getLaunchUserName(portal) } }}</strong>
                      }
                    </span>
                  </div>
                  @if (portal.service.launched_at) {
                    <div
                      class="launch-production-info__date"
                      (mouseenter)="setLaunchDateEditActionVisible(true)"
                      (mouseleave)="setLaunchDateEditActionVisible(false)"
                      (focusin)="setLaunchDateEditActionVisible(true)"
                      (click)="setLaunchDateEditActionVisible(true)"
                      [attr.tabindex]="canEditLaunchDate(portal) ? 0 : null"
                      [attr.aria-label]="canEditLaunchDate(portal) ? ('myPortal.launch.editDate' | translate) : null">
                      @if (editingLaunchDate) {
                        <input
                          matInput
                          class="launch-production-info__date-input"
                          [matDatepicker]="launchDatePicker"
                          [value]="launchDateDraft"
                          [max]="maxLaunchDate"
                          readonly
                          [disabled]="savingLaunchDate"
                          [attr.aria-label]="'myPortal.launch.editDate' | translate"
                          (dateChange)="onLaunchDateChange($event.value)">
                        <mat-datepicker-toggle class="launch-production-info__date-picker" [for]="launchDatePicker" [disabled]="savingLaunchDate"></mat-datepicker-toggle>
                        <mat-datepicker #launchDatePicker></mat-datepicker>
                        <button type="button" class="launch-production-info__date-confirm" [disabled]="savingLaunchDate" [attr.aria-label]="'myPortal.launch.confirm' | translate" (click)="saveLaunchDate(portal)">
                          @if (savingLaunchDate) {
                            <span class="launch-production-info__date-loader" aria-hidden="true"></span>
                          } @else {
                            <mat-icon>check</mat-icon>
                          }
                        </button>
                        <button type="button" class="launch-production-info__date-cancel" [disabled]="savingLaunchDate" [attr.aria-label]="'myPortal.launch.cancel' | translate" (click)="cancelLaunchDateEdit()">
                          <mat-icon>close</mat-icon>
                        </button>
                      } @else {
                        <span>{{ portal.service.launched_at | date:'dd/MM/yyyy · HH:mm:ss' }}</span>
                        @if (canEditLaunchDate(portal) && showLaunchDateEditAction) {
                          <button type="button" class="launch-production-info__date-edit" [attr.aria-label]="'myPortal.launch.editDate' | translate" (click)="startLaunchDateEdit(portal)">
                            <mat-icon>edit</mat-icon>
                          </button>
                        }
                      }
                    </div>
                  }
                </div>
              }
            }
            <div class="box-detail">
                  <div class="block-one">
                    <h3>{{ 'myPortal.subscription' | translate }}</h3>
                    <p>{{ 'myPortal.modified' | translate }} {{ portal.service.updatedAt }}</p>
                  </div>
                  <div class="block-two">
                  <div class="left-block">
                    <!-- <button  *ngIf="portal.customerHasPlan != null && portal.customerHasPlan.status_customerPlan == 1"     class="bot"  (click)="goAddClient(portal)"> -->

                    
                         
                      <button 
                      [ngClass]="{'disable': !canUsePortal(portal)}"
                      (click)="onButtonClick(portal, 'subscription')"  
                      class="bot">
                      <img src="/assets/icons/plus-circle.svg" alt="">
                      {{ 'myPortal.buttons.affiliate' | translate }}
                    </button>
                    
                    <!-- Botón Cobro único -->
                    <button 
                      [ngClass]="{'disable': !canUsePortal(portal)}"
                      (click)="onButtonClick(portal, 'onetime_payment')"  
                      class="bot">
                      <img src="/assets/icons/mail.png" alt="">
                      {{ 'myPortal.buttons.paymentLink' | translate }}
                    </button>                     

                    <!-- <button  *ngIf="portal.customerHasPlan == null || portal.customerHasPlan.status_customerPlan != 1"    class="bot disable" (click)="goAddClient(portal)">
                      <span>Debe tener una suscripción activa</span>
                      <img src="/assets/icons/plus-circle.svg" alt="">
                      Afiliar cliente
                    </button> -->
                   
                 
                  <button class="bot"  (click)="goEdit(portal)">
                    <img src="/assets/icons/pencil.svg" alt="">
                    {{ 'myPortal.buttons.edit' | translate }}
                  </button>

                  <button class="bot bot-new"  (click)="goEditPlans(portal)">
                    <img src="/assets/icons/plan1.svg" alt="">
                    <span class="bot-label">{{ 'myPortal.buttons.editPlans' | translate }}</span>
                    <span class="new-badge">{{ 'myPortal.buttons.new' | translate }}</span>
                  </button>
                  </div>
                      <div class="status-plan">
                        <button style="color: white;" class="inactivo status" *ngIf="canUsePortal(portal)"  (click)="goDeactivatePortal(portal)">{{ 'myPortal.buttons.deactivate' | translate }}</button>
                        <!-- <button style="color: white;" class="inactivo status" *ngIf="(portal.customerHasPlan != null && portal.customerHasPlan.status_customerPlan != 1) || (!portal.isActive  &&  portal.customerHasPlan == null && portal.service.current_onboarding_step >= 4) || (!showDeactivate && !isValidDate)  ">Reactivar suscripción</button> -->
                        <button style="color: white;" class="draf status" *ngIf="canActivateOnboardingPortal(portal)" (click)="goActivatePortal(portal)">{{ 'myPortal.buttons.activateService' | translate }}</button>
                        <button style="color: white;" class="draf status"*ngIf="shouldShowPaymentButton(portal)" (click)="processPayment(portal)">{{ 'myPortal.buttons.activate' | translate }}</button>
                        <!-- <button style="color: white;" class="procesando status" *ngIf="!portal.isActive && portal.customerHasPlan != null && portal.customerHasPlan.status_customerPlan == 1 && isValidDate" [matMenuTriggerFor]="menu">Procesando</button> -->
                    </div>
                  </div>
              

                <mat-menu class="option-portal" #menu="matMenu">
                </mat-menu>

            </div>
            
            <div class="content-portal">
              <h2 >{{ portal.service.name_service }}</h2>
              
            </div>
            <div *ngIf="portal.onboardingPortalContent == null" class="nuevo-portal">
              <div class="leftdato"><img src="/assets/icons/box.svg" alt="">
              <h3>{{ 'myPortal.portal.title' | translate }}</h3>
              <p>{{ 'myPortal.portal.description' | translate }}</p></div>
            <button (click)="goToTemplates(portal,false)">{{ 'myPortal.buttons.createPortal' | translate }}</button>
            </div>
            
              <div *ngIf="portal.onboardingPortalContent != null" class="editar-portal">
                <div class="portal-sub">
                  <img src="/assets/icons/box-white.svg" alt="">
                  <h3>{{ 'myPortal.portal.affiliationPortal' | translate }}</h3>
                </div>
                <div class="custom-portal">
                  <button (click)="goToTemplates(portal,true)" > <img src="/assets/icons/pencil-white.svg" alt="">{{ 'myPortal.buttons.editTemplate' | translate }}</button>
                  <button (click)="goToFeatures(portal)" > <img src="/assets/icons/pencil-white.svg" alt="">{{ 'myPortal.buttons.editColors' | translate }}</button>
                  <button *ngIf="isPortalActive" (click)="goToPortal(portal.url_client)" > <img src="/assets/icons/eye-white.svg" alt="">{{ 'myPortal.buttons.preview' | translate }}</button>
                  <button *ngIf="!isPortalActive" (click)="goToPortal(getUrlTemplateWithIdentifier())">
                    <img src="/assets/icons/eye-white.svg" alt="">{{ 'myPortal.buttons.preview' | translate }}
                  </button>
                </div>
                </div>
              </div>

              @if (launchToProductionEnabled) {
                <ng-template #launchConfirmationDialog>
                  <div class="launch-confirm-dialog">
                    <div class="launch-confirm-dialog__icon">!</div>
                    <h2>{{ 'myPortal.launch.modalTitle' | translate }}</h2>
                    <p>{{ 'myPortal.launch.modalDescription' | translate }}</p>
                    <strong>{{ launchTargetPortal?.service?.name_service }}</strong>
                    <input
                      type="text"
                      [value]="launchConfirmationValue"
                      (input)="launchConfirmationValue = $any($event.target).value"
                      [placeholder]="'myPortal.launch.modalInputPlaceholder' | translate">
                    <div class="launch-confirm-dialog__actions">
                      <button type="button" class="launch-confirm-dialog__cancel" (click)="cancelLaunchConfirmation()">{{ 'myPortal.launch.cancel' | translate }}</button>
                      <button
                        type="button"
                        class="launch-confirm-dialog__confirm"
                        [disabled]="!launchConfirmationMatches"
                        (click)="confirmLaunchToProduction()">
                        {{ 'myPortal.launch.confirm' | translate }}
                      </button>
                    </div>
                  </div>
                </ng-template>
              }
          
